export enum OcbSharePointAuthenticationModes {
    AccountPassword = 0,
    EntraId = 1
}
